/**
 * Tanjong Life · the rehearsal trap, answered.
 *
 * The A2A tab on the Fraud Score Agent carries a "Migrate to Wand-native" banner, and
 * sooner or later somebody in the room asks for it — often the person who has just been
 * shown how much richer the native agent's page is. The answer is no, and the reason is
 * the argument of the whole act rather than a limitation.
 *
 * Scoped to `fraud-score-agent`, registered AFTER `tanjong-chat-external` (also scoped to
 * that agent) and before the builds. The two keyword sets are disjoint: nothing here
 * contains `score claim`, `why 78`, `why did it score` or `what are the reasons`.
 *
 * No mutation steps. Declining to move something must not move it.
 */
import type { Scenario } from '../director.js';

export const tanjongMigrateDecline: Scenario = {
  id: 'tanjong-migrate-decline',
  orgId: 'tanjong-life',
  agentPk: 'fraud-score-agent',
  keywords: ['migrate the fraud score', 'migrate to wand-native', 'bring it in-house'],
  steps: [
    {
      do: 'say',
      text: 'It stays external — that is the point, not a gap in the plan.',
      delay: 500,
    },
    {
      do: 'say',
      text: 'The carrier owns this model. It was built on their book, it is theirs to change, and they are not going to hand over the weights so that a platform can hold a copy — nor should they be asked to. What this platform is for is everything around it: the process invokes it under a named identity, the invocation is recorded with what went in and what came back, the Claims Fraud Analyst turns the number into nine terms a person can argue with, and the SIU Triage Sentinel watches what happens to the rank afterwards. Absorbing the model would buy a richer agent page and lose the one thing worth having, which is that the number and the explanation of the number are produced by two parties who can disagree.',
      sources: ['tl-pr12 · a3 runs on another runtime, over A2A', 'Invocations · 1,284 calls recorded'],
      delay: 1400,
    },
    {
      do: 'say',
      text: 'So the honest version of the banner is: leave it where it is, and make what it returns explainable and governed on this side. That is what the rest of this workflow does.',
      delay: 1100,
    },
  ],
};
